import React from 'react';
import ReactDOM from 'react-dom';
import Home from './components/Home/Home';
import './mainStyle.css';

ReactDOM.render(
  <React.StrictMode>
    <Home />
  </React.StrictMode>,
  document.getElementById('root')
);
